import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { themeMUI } from 'styles/themeMUI';
import { Container, Main } from './Layout.styled';
import { Footer } from '../Footer/Footer';
import { Header } from '../Header/Header';

export const Layout = () => {
  return (
    <>
      <ThemeProvider theme={themeMUI}>
        <Header />
        <Main>
          <Container>
            <Suspense fallback={null}>
              <Outlet />
            </Suspense>
          </Container>
        </Main>
        <footer>
          <Footer />
        </footer>
      </ThemeProvider>
    </>
  );
};
